import { uiText, useUiLanguage } from '@/i18n/interface';
import React from 'react';
import { Alert, AlertDescription } from "@/components/ui/alert";
import { CheckCircle, AlertTriangle } from 'lucide-react';

interface LoginAlertsProps {
  checkEmailMessage: boolean;
  emailConfirmedMessage?: boolean;
  isLocked: boolean;
  loginAttempts: number;
}

export const LoginAlerts: React.FC<LoginAlertsProps> = ({
  checkEmailMessage,
  emailConfirmedMessage,
  isLocked,
  loginAttempts
}) => {
  useUiLanguage();
  return (
    <>
      {checkEmailMessage && (
        <Alert className="border-blue-200 bg-blue-50">
          <CheckCircle className="h-4 w-4 text-blue-600" />
          <AlertDescription className="text-blue-800">
            {uiText("Registration successful! Please check your email and click the confirmation link before logging in.")}</AlertDescription>
        </Alert>
      )}

      {emailConfirmedMessage && (
        <Alert className="border-green-200 bg-green-50">
          <CheckCircle className="h-4 w-4 text-green-600" />
          <AlertDescription className="text-green-800">
            {uiText("Email confirmed successfully! You can now log in with your credentials.")}</AlertDescription>
        </Alert>
      )}

      {isLocked && (
        <Alert className="border-red-200 bg-red-50">
          <AlertTriangle className="h-4 w-4 text-red-600" />
          <AlertDescription className="text-red-800">
            {uiText("Account temporarily locked due to multiple failed login attempts. Please try again in 15 minutes.")}</AlertDescription>
        </Alert>
      )}

      {loginAttempts > 0 && loginAttempts < 5 && !isLocked && (
        <Alert className="border-yellow-200 bg-yellow-50">
          <AlertTriangle className="h-4 w-4 text-yellow-600" />
          <AlertDescription className="text-yellow-800">
            {5 - loginAttempts} {' '}{uiText("login attempts remaining before temporary lockout.")}</AlertDescription>
        </Alert>
      )}
    </>
  );
};